import { API_BASE_URL } from "@/config";
import { PREPOPULATE_INPUT } from "@/utils/prepopulate_input.js";
import { MAIN_CONTROLLER } from "@/utils/main_controller.js";
import { validateToken } from "@/utils/auth";
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb.vue";
import ClientLogo from "@/components/ClientLogo/ClientLogo.vue";
import Swal from "sweetalert2";

export default {
    name: 'MastercardMatchInquiry',
    mixins: [MAIN_CONTROLLER, PREPOPULATE_INPUT],
    data() {
        return {
            form: {
                merchant_name: '',
                merchant_address_line_one: '',
                merchant_address_line_two: '',
                merchant_city: '',
                merchant_country: '',
                merchant_phone_number: '',
                merchant_category: '',
                principal_first_name: '',
                principal_last_name: '',
                principal_address_line_one: '',
                principal_address_line_two: '',
                principal_city: '',
                principal_country: '',
                principal_phone_number: '',
                principal_email: ''
            }
        };
    },
    components: {
        BreadCrumb,
        ClientLogo
    },
    computed: {
        workflow_id() {
          return this.$store.getters.get_workflow_id;
        }
    },
    methods: {
        submit_mastercard_match_inquiry() {
            this.mastercard_match_inquiry_api();
        },
        mastercard_match_inquiry_api() {
            const TOKEN = localStorage.getItem('token');
            const MASTERCARD_MATCH_INQUIRY_API = `${API_BASE_URL}/verify_api/compliance_verification/mastercard_match_inquiry/`;

            $.ajax({
                url: MASTERCARD_MATCH_INQUIRY_API,
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                data: JSON.stringify({
                    merchant_name: this.form.merchant_name,
                    merchant_address_line_one: this.form.merchant_address_line_one,
                    merchant_address_line_two: this.form.merchant_address_line_two,
                    merchant_city: this.form.merchant_city,
                    merchant_country: this.form.merchant_country,
                    merchant_phone_number: this.form.merchant_phone_number,
                    merchant_category: this.form.merchant_category,
                    principal_first_name: this.form.principal_first_name,
                    principal_last_name: this.form.principal_last_name,
                    principal_address_line_one: this.form.principal_address_line_one,
                    principal_address_line_two: this.form.principal_address_line_two,
                    principal_city: this.form.principal_city,
                    principal_country: this.form.principal_country,
                    principal_phone_number: this.form.principal_phone_number,
                    principal_email: this.form.principal_email,
                    workflow_id: this.workflow_id,
                    on_behalf_application: this.$route.name === 'behalf_application' ? true : false,
                }),
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading(),
                    });
                },
                success: () => {
                    Swal.close();
                    Swal.fire({
                        icon: 'success',
                        title: 'Successful',
                        text: 'Mastercard Match Inquiry Submitted Successfully',
                        timer: 3000,
                        timerProgressBar: true,
                        showConfirmButton: false
                    }).then(() => {
                        this.completeService();
                    });
                },
                error: (error) => {
                    Swal.close();
                    let error_message = 'Something went wrong!';

                    if (error.responseJSON && error.responseJSON.message) {
                        error_message = error.responseJSON.message;
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: error_message,
                        timer: 3000,
                        showConfirmButton: false
                    });
                }
            });
        }
    },
    mounted() {
        if (!validateToken(this.$router)) {
            return;
        }
    }
};
